import styled from 'styled-components';

export const CreditCardContainer = styled.div`
  &:focus,
  &:focus-within {
    #field-wrapper {
      outline: 1px dotted #212121;
      outline: 5px auto -webkit-focus-ring-color;
    }
  }

  > div:first-child {
    div#field-wrapper {
      display: inline-flex;
      border: 1px solid #e9eef3;
      border-radius: 4px;
      font-size: 16px;
      height: 66px;
    }
    input {
      height: auto;
      color: #9b9b9b;
      letter-spacing: 0.333px;
      font-weight: 300;
      padding: 0px;
    }
    label {
      font-size: inherit;
      padding-right: 16px;
    }

    #card-expiry {
      width: 88px;
    }

    #cvc {
      width: 72px;
    }
  }
`;
